export default "__VITE_ASSET__870f7def__"